<template>
    <section class="lucky">
        <div class="lucky-logo"></div>
        <div class="lucky-container">
            <div class="lucky-canvas">
                <LuckyWheel ref="LuckyWheel" :blocks="canvasData.blocks" :prizes="canvasData.prizes" :buttons="canvasData.buttons" @start="StartLuckyWheel" @end="EndLuckyWheel" class="lucky-canvas-pie" />
            </div>
            <div class="lucky-gold"></div>
        </div>
        <template v-if="$store.state.openid">
            <div class="lucky-times">您今天有 <strong>{{ initData.count >= 0 ? initData.count : 2 }}</strong> 次机会，邀请好友增加次数！</div>
        </template>
        <div class="lucky-btns" v-if="$store.state.openid">
            <button class="lucky-btn" @click="componentData.shareDetail.visible = true">邀请好友</button>
            <button class="lucky-btn" @click="GetMy">我的奖品</button>
        </div>
        <div class="lucky-rule">
            <h2>抽奖规则</h2>
            <p>1、活动时间：{{ initData.startTime }} ~ {{ initData.endTime }}</p>
            <p>2、每个用户每天有一次抽奖机会，邀请好友参加活动额外增加抽奖机会。</p>
            <p>3、工作人员将在活动结束后三个工作日内与您联系，奖品会陆续发出，请耐心等待。</p>
            <p>4、本活动最终解释权归属北京和牧同兴农牧科技有限公司所有。</p>
            <p class="t-center"><a href="tel:400-669-8210" class="t-warning">400-669-8210<a></p>
        </div>

        <template v-if="winData.list[winData.index] && winData.list[winData.index].nickname">
            <div :key="index" class="lucky-win-tips"><img :src="winData.list[winData.index].headimgurl || require('../../assets/img/default.png')">{{ winData.list[winData.index].nickname.slice(0, 3) }}... 抽到{{ winData.list[winData.index].prize }}</div>
        </template>
        <template v-if="tips.result.visible">
            <div class="lucky-result-tips">
                <div class="lucky-result-tips-main">
                    <van-icon name="cross" @click="tips.result.visible = false" />
                    <div class="lucky-result-tips-header">我的奖品</div>
                    <div class="lucky-result-tips-container">
                        <div class="lucky-result-tips-text" v-if="tips.result.data.title">
                            <van-notice-bar left-icon="volume-o" :text="'恭喜您！获得了' + tips.result.data.title + '，填写您的信息，领取奖品。'" scrollable />
                            <van-form @submit="SubmitForm">
                                <van-field v-model="infoData.mobile" type="mobile" name="mobile" label="手机号" placeholder="您的手机号" :rules="[{ required: true, message: '请填写您的手机号' }]" />
                                <van-field v-model="infoData.address" name="address" label="地址" placeholder="您的收货地址" :rules="[{ required: true, message: '请填写您的收货地址' }]" />
                                <div style="padding-top: 18px">
                                    <van-button type="danger" size="small" block plain round native-type="submit">提交</van-button>
                                </div>
                            </van-form>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <v-Share :componentData="componentData.shareDetail" v-if="componentData.shareDetail.visible" />
    </section>
</template>

<script>
import { Toast } from 'vant'
import wx from 'weixin-js-sdk'
import Share from '@/components/share'
export default {
    components: {
        'v-Share': Share
    },
    inject: ['reload'],
    data() {
        return {
            initData: {
                list_id: null,
                startTime: null,
                endTime: null,
                prize: null,
                count: null
            },
            canvasData: {
                blocks: [{
                    padding: '10px',
                    background: '#d64737'
                }],
                prizes: [{}],
                buttons: [{radius: '30px', background: '#fff'}]
            },
            winData: {
                index: 0,
                list: []
            },
            infoData: {
                address: null,
                mobile: null
            },
            tips: {
                result: {
                    visible: false,
                    data: {
                        wid: null,
                        title: null
                    }
                }
            },
            componentData: {
                shareDetail: {
                    visible: false
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {
            // 主动进入
            if (this.$route.query.list_id) {
                if (this.$route.query.code) {
                    this.GetCode()
                } else {
                    this.GetInfo()
                }
                this.GetWin()
            }
            // 通过分享进入
            if (this.$route.query.openid) {
                this.GetShare()
            }
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {
        // 活动信息
        GetInfo() {
            this.$request({
                url: '/api/v1/getinfo',
                data: this.$qs.stringify({
                    list_id: this.$route.query.list_id,
                    u: this.$store.state.openid
                })
            })
            .then((res) => {
                if (!res.status) {
                    this.initData.list_id = this.$route.query.list_id
                    this.initData.startTime = res.data.starttime.split(' ')[0]
                    this.initData.endTime = res.data.endtime.split(' ')[0]
                    this.initData.prize = res.data.prize
                    this.initData.count = res.data.count

                    this.$store.commit('setInitData', this.initData)
                    this.CreateLuckyWheel()
                }
            })
        },
        // 获奖列表
        GetWin() {
            this.$request({
                url: '/api/v1/winprizelist',
                data: this.$qs.stringify({
                    list_id: this.$route.query.list_id
                })
            })
            .then((res) => {
                if (!res.status) {
                    this.winData.list = res.data
                    setInterval(() => {
                        if (this.winData.index == (this.winData.list.length - 1)) {
                            this.winData.index = 0
                        } else {
                            this.winData.index++
                        }
                    }, 5500)
                }
            })
        },
        // 分享次数
        GetShare() {
            this.$request({
                url: '/api/v1/share',
                data: this.$qs.stringify({
                    list_id: this.$route.query.list_id,
                    u: this.$route.query.openid
                })
            })
        },
        GetCode() {
            this.$request({
                url: '/api/v1/getcode',
                data: this.$qs.stringify({
                    list_id: this.$route.query.list_id,
                    code: this.$route.query.code
                })
            })
            .then((res) => {
                if (!res.status) {
                    this.$store.commit('setOpenId', res.data.openid)
                } else {
                    if (res.message != 'error3') {
                        Toast(res.message)
                    }
                }
                setTimeout(() => {
                    this.GetInfo()
                    this.GetConfig()
                }, 200)
            })
        },
        GetConfig() {
            let shareData = {
                title: '老铁！！！您今天还没抽奖~赶紧来',
                desc: '在页面中间弹出黑色半透明提示',
                link: 'http://activity.hemutx.com/lucky/turntable?list_id=' + this.$route.query.list_id + '&openid=' + this.$store.state.openid,
                imgUrl: 'http://activity.hemutx.com/img/bg.6e9effae.jpg',
                success: () => {
                    // 设置成功
                },
                cancel: () => {
                    // 设置失败
                }
            }
            this.$request({
                url: '/api/v1/getconfig',
                data: this.$qs.stringify({
                    url: window.location.href.split('#')[0]
                })
            })
            .then((res) => {
                if (!res.status) {
                    wx.config({
                        debug: false,
                        appId: res.data.appid,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ['updateAppMessageShareData','updateTimelineShareData']
                    })
                    wx.ready(() => {
                        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                        wx.updateAppMessageShareData(shareData)
                        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
                        wx.updateTimelineShareData(shareData)
                    })
                }
            })
        },
        // 我的奖品
        GetMy() {
            this.$request({
                url: '/api/v1/myprize',
                data: this.$qs.stringify({
                    list_id: this.$store.state.initData.list_id,
                    u: this.$store.state.openid
                })
            })
            .then((res) => {
                if (!res.status) {
                    if (res.data.length) {
                        this.tips.result.visible = true
                        this.tips.result.data.wid = res.data[0].wid
                        this.tips.result.data.title = res.data[0].prize
                    } else {
                        Toast('您还没有中奖哦！')
                    }
                }
            })
        },
        CreateLuckyWheel() {
            this.canvasData.prizes = []
            this.initData.prize.forEach((item, index) => {
                this.canvasData.prizes.push({
                    id: index,
                    title: item.prizetitle,
                    background: index % 2 ? '#ff7b7a' : '#fdc76c',
                    fonts: [{ text: item.prizetitle, top: '25%', fontSize: '12px', fontColor: '#fff' }]
                })
            })
            this.canvasData.buttons = [{
                imgs: [{src: require('../../assets/img/lucky/turntable/arrow.png'), top: '-40px', width: '80px', height: '80px'}, {src: this.$store.state.openid ? require('../../assets/img/lucky/turntable/text_handle.png') :  require('../../assets/img/lucky/turntable/text_login.png'), top: '-19px', width: '36px', height: '38px'}]
            }]
        },
        StartLuckyWheel() {
             if (this.$store.state.openid) {
                this.$request({
                    url: '/api/v1/index',
                    data: this.$qs.stringify({
                        list_id: this.$store.state.initData.list_id,
                        u: this.$store.state.openid
                    })
                })
                .then((res) => {
                    if (!res.status) {
                        this.$refs.LuckyWheel.play()
                        this.$refs.LuckyWheel.stop(res.data.num)
                        this.GetInfo()
                    } else {
                        Toast(res.message)
                    }
                })
            } else {
                window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd17e4e424e2f35b8&redirect_uri=http://activity.hemutx.com/lucky/turntable?list_id=' + this.$route.query.list_id + '&response_type=code&scope=snsapi_userinfo#wechat_redirect')
            }
        },
        EndLuckyWheel(prize) {
            if (prize.id < (this.canvasData.prizes.length - 1)) {
                this.GetMy()
            } else {
                Toast('很遗憾，大奖与你擦肩而过再接再厉！')
            }
        },
        // 提交中奖者信息
        SubmitForm() {
            this.$request({
                url: '/api/v1/uinformation',
                data: this.$qs.stringify({
                    u: this.$store.state.openid,
                    list_id: this.$store.state.initData.list_id,
                    wid: this.tips.result.data.wid,
                    ...this.infoData
                })
            })
            .then((res) => {
                if (!res.status) {
                    Toast('提交成功，等待工作人员核实！')
                    this.tips.result.visible = false
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.lucky {
    min-height: 100vh;
    padding-top: 32px;
    box-sizing: border-box;
    background: #e74143 url('../../assets/img/lucky/turntable/bg.jpg') no-repeat 50% 0;
    background-size: 100%;
    color: #fff;
    position: relative;
    &-result-tips {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, .75);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
        &-main {
            margin: auto;
            width: 295px;
            border-radius: 4px;
            background-color: #fff;
            position: relative;
            overflow: hidden;
            .van-icon {
                font-size: 28px;
                position: absolute;
                top: 16px;
                right: 10px;
            }
        }
        &-header, &-container {
            padding: 10px 20px;
        }
        &-header {
            font-size: 20px;
            font-weight: bold;
            line-height: 2;
            text-shadow: 2px 2px 5px rgba(0, 0, 0, .1);
            background: #e74143;
            color: #fff;
        }
        &-container {
            text-align: center;
        }
        &-text {
            margin-bottom: 10px;
            font-size: 14px;
            text-align: justify;
            color: #860e0e;
            h2 {
                margin: 0;
                font-size: 16px;
            }
            span {
                margin-left: 20px;
                &:first-child {
                    margin: 0;
                }
            }
        }
    }
    &-win-tips {
        display: inline-flex;
        align-items: center;
        height: 24px;
        padding: 0 10px 0 5px;
        border-top-right-radius: 9999px;
        border-bottom-right-radius: 9999px;
        background-color: rgba(0, 0, 0, .4);
        line-height: 24px;
        position: fixed;
        top: 15px;
        left: 0;
        img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
            border-radius: 9999px;
        }
    }
    &-logo {
        width: 254px;
        height: 93px;
        margin: 0 auto;
        background: url('../../assets/img/lucky/turntable/logo.png') no-repeat 50%;
        background-size: cover;
    }
    &-container {
        width: 238px;
        height: 270px;
        margin: 20px auto 0;
        position: relative;
    }
    &-canvas {
        width: 250px;
        height: 250px;
        border-radius: 9999px;
        position: relative;
        overflow: hidden;
        &-pie {
            width: 250px;
            height: 250px;
            margin: auto;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
        }
        &-handle {
            width: 238px;
            height: 239px;
            background: url('../../assets/img/lucky/turntable/canvas.png') no-repeat 50%;
            background-size: cover;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
        }
    }
    &-shadow {
        width: 216px;
        height: 20px;
        margin: 12px auto 0;
        background: url('../../assets/img/lucky/turntable/shadow.png') no-repeat 50%;
        background-size: cover;
    }
    &-gold {
        width: 248px;
        height: 75px;
        background: url('../../assets/img/lucky/turntable/gold.png') no-repeat 50%;
        background-size: cover;
        position: absolute;
        top: 164px;
        left: -16px;
    }
    &-times {
        font-size: 16px;
        text-align: center;
        line-height: 36px;
        strong {
            padding: 0 5px;
            font-size: 24px;
            font-weight: bold;
        }
    }
    &-btns {
        padding: 10px 0 30px;
        text-align: center;
    }
    &-btn {
        width: 96px;
        height: 32px;
        margin: 0 10px;
        border: 0 none;
        background: url('../../assets/img/lucky/turntable/btn.png') no-repeat 50%;
        background-size: cover;
        font-size: 12px;
        color: #6c4104;
    }
    &-rule {
        padding: 0 25px 20px;
        font-size: 12px;
        line-height: 1.8;
        h2 {
            margin: 0;
            font-size: 16px;
        }
    }
}

.van-cell {
    padding: 10px 0;
    &::after {
        left: 0;
        right: 0;
    }
}
</style>